import { HttpMethods, RequestPerformer } from '@/api/api-requests-factory';
import { Ref } from 'vue';
import { GetDocumentListRequest } from '@/api/documents/get-document-list.request';
import { CreateDocumentModerationRequest } from '@/api/documents/create-document-moderation.request';

export class DocumentListApiResources {
  constructor(
    private readonly requestPerformer: RequestPerformer,
    private readonly multibrandApiHost: Ref<string>,
  ) {}

  public get getDocumentListRequest(): GetDocumentListRequest {
    return new GetDocumentListRequest(
      this.requestPerformer,
      `${this.multibrandApiHost.value}/api/v1.0/front/proxy`,
      HttpMethods.GET,
    );
  }

  public get createDocumentModerationRequest(): CreateDocumentModerationRequest {
    return new CreateDocumentModerationRequest(
      this.requestPerformer,
      `${this.multibrandApiHost.value}/api/v1.0/front/proxy`,
      HttpMethods.POST,
    );
  }
}
